import { combineReducers, applyMiddleware, createStore, Reducer } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import { ITagsState } from 'types'
import globalMessaging from 'utils/reducers/globalMessaging'
import mapboxReducer from 'utils/reducers/mapbox'
import shipmentNoteTagsReducer from 'utils/reducers/shipmentNoteTags'
import tagsReducer from 'utils/reducers/tags'
import { globalMiddleware } from 'utils/middleware'
import amQuoting from './amQuoting'
import bulkQuoting from './bulkQuoting'
import carrierApplication from './carrierApplication'
import carrierContractLanes from './contractLanes'
import laneAlerts from './laneAlerts'
import laneMetrics from './laneMetrics'
import priceRequest from './priceRequest'
import routingGuide from './routingGuide'
import shipment from './shipment'
import shipperLane from './shipperLane'
import shipperLanes from './shipperLanes'
import transfixLane from './transfixLane'
import transfixLanes from './transfixLanes'

const rootReducer = combineReducers({
  globalMessaging,
  laneMetrics,
  transfixLane,
  transfixLanes,
  carrierContractLanes,
  routingGuide,
  laneAlerts,
  shipment,
  carrierApplication,
  shipperLane,
  shipperLanes,
  tags: tagsReducer as Reducer<ITagsState>,
  shipmentNoteTags: shipmentNoteTagsReducer,
  amQuoting,
  bulkQuoting,
  priceRequest,
  mapbox: mapboxReducer,
})

export const configureStore = (preloadedState = {}) => {
  const middleware = [thunkMiddleware, ...globalMiddleware]
  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 30 })
  const composedEnhancers = composeEnhancers(applyMiddleware(...middleware))
  const store = createStore(rootReducer, preloadedState, composedEnhancers)
  return store
}
